import Link from 'next/link';
import { styled } from 'styled-components';
export const CustomLink = styled(Link).withConfig({
  displayName: "SurpriseMenuFloatButtonstyle__CustomLink",
  componentId: "sc-10ac2oe-0"
})(["", " top:calc(100vh - 225px);@media (max-width:", "){", "}"], {
  "position": "sticky",
  "right": "1.75rem",
  "zIndex": "40",
  "marginBottom": "-9px",
  "marginTop": "-120px",
  "marginLeft": "auto",
  "height": "auto",
  "width": "100px"
}, ({
  theme
}) => theme.breakpoint.md, {
  "right": "0.5rem",
  "marginBottom": "-105px",
  "marginTop": "-1.5rem"
});